export class TitleOfTheDocument {
  title: String = '';
  achievement_type: number = null;
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/personal-achievements/TitleOfTheDocument.ts